import { ROLE } from 'services/assist-api/entities/role/roles';
import { hasRole } from './helpers';
import type { AuthorisableUser } from './types';

/**
 * Authorisation rules for the resource that the policy is named after.
 * Functions return true only if the user can perform the action.
 * Follows the policy pattern used in Gate (Laravel) and Pundit (Rails).
 */
export default class MarkingGroupPolicy {
  static list(user: AuthorisableUser): boolean {
    if (!user.belongsToMarkingOrganisation) return false;
    return hasRole(user, [ROLE.SITE_ADMIN]);
  }

  static show(user: AuthorisableUser): boolean {
    return this.list(user);
  }

  static create(user: AuthorisableUser): boolean {
    return this.list(user);
  }

  static update(user: AuthorisableUser): boolean {
    return this.list(user);
  }

  static delete(user: AuthorisableUser): boolean {
    return this.list(user);
  }
}
